import { useQuery } from '@tanstack/react-query';

import { getTeamEventsToday } from '../apis';
import { teamKeys } from './teamKeys';

export const useTeamEventsToday = () =>
  useQuery({
    queryKey: teamKeys.eventsToday(),
    queryFn: getTeamEventsToday,
  });
